import React, { Component } from 'react';
import GlobalStoreService from "../../services/global-store.service";
import Carousel from 'nuka-carousel'
import BotType from '../../enums/BotType';
import { globalConstants } from "../../constants/globalConstants";
import IdleTimeoutService from "../../services/idle-timeout.service";
import UserAction from '../../services/handle-user-action.service'
import UtilService from "../../services/util.service";

const userAccountsMenu = ({ onNumberSelected, initiateScenarioAfterLogin, setBottomBarComponentState, addNewMessages, initiate_after_login_in_multiple = false }) => {

    let userProfile = GlobalStoreService.get('userProfile');

    const selectNumber = (account) => {
        IdleTimeoutService.updateIdleState();
        setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })
        GlobalStoreService.set("currentNumber", account.siNumber);
        GlobalStoreService.set("currentBotType", account.type);

        if (GlobalStoreService.get("loginViaOtp") || initiate_after_login_in_multiple) {
            GlobalStoreService.set("loginViaOtp", false);
            addNewMessages({ new_messages: [UtilService.createUserMessageObject(`${account.siNumber}`), UtilService.createChatBotMessageObject(globalConstants.number_selected_acknowledgement_msg)] })
            initiateScenarioAfterLogin();

        } else {
            onNumberSelected({ user_response: account.siNumber, show_number: true });
        }

    }
    // let numbers_to_show = UtilService.getUserProfileNumbersWithAccountType()
    const numbers_to_show = GlobalStoreService.get("userAccounts")

    const renderNumbers = () => {
        let carousel_slides = []
        for (let i = 0; i < Math.ceil(numbers_to_show.length / 6); i++) {
            carousel_slides.push(<div className={`services-bar item ${(i === 0) ? 'active' : ''}`}
                style={{ paddingTop: '15px', width: 'auto' }}>
                <ul className='width-full' style={{ float: "left" }}>
                    {numbers_to_show.map((item, index) => {
                        if (index >= 6 * i && index < 6 * (i + 1)) {
                            return (
                                <li className="fs-14" onClick={() => { selectNumber(item) }}>
                                    <span className="display-block color-grey fs-11" title={item.customerName && item.customerName}>{item.customerName && item.customerName.toString().length > 20 ? item.customerName.toString().substr(0, 18) + '...' : item.customerName}</span>
                                    <span>{item.siNumber}</span>
                                    <span className=" display-block color-grey fs-9" title={item.type && item.type}>{BotType.getNumberTypeToShow(item.type)}</span>
                                </li>
                            )
                        }
                    })}
                </ul></div>)
        }
        return (carousel_slides.map(item => item))
    }

    const calculateRows = () => {
        if (numbers_to_show.length <= 2) {
            return 1
        }
        else if (numbers_to_show.length <= 4) {
            return 2
        }
        else if (numbers_to_show.length > 4) {
            return 3
        }
    }
    let slide_height = 80 + ((36 + 18) * (calculateRows()))

    return (
        <div className="home user_accounts_menu" >
            <Carousel initialSlideHeight={`${slide_height}px`} width={window.innerWidth} slideWidth={1.0}>
                {userProfile && userProfile.products && numbers_to_show && numbers_to_show.length > 0 && renderNumbers()}
            </Carousel>
        </div>
    )
}


export default userAccountsMenu


// WEBPACK FOOTER //
// ./src/components/bottom-components/user-accounts-menu.component.js